import { render, staticRenderFns } from "./SchoolStudents.vue?vue&type=template&id=12a85d54&"
import script from "./SchoolStudents.vue?vue&type=script&lang=js&"
export * from "./SchoolStudents.vue?vue&type=script&lang=js&"
import style0 from "./SchoolStudents.vue?vue&type=style&index=0&id=12a85d54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports